<div class="page-container">
  <div class="container">

    <mat-card class="campaigns-card">
      <div class="manage-campaigns-header-row">
        <button
          mat-icon-button
          type="button"
          class="back-to-orders-btn"
          routerLink="/orders"
          aria-label="Back to orders">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="card-header user-header manage-campaigns-header-main">
        <div class="user-header-text">
          @if (activeOrderId && allSchedules.length > 0) {
            <div class="station-header-info">
              @if (station_logo_url) {
                <img [src]="station_logo_url" alt="Station Logo" class="station-header-logo">
              } @else {
                <div class="station-placeholder">
                  {{ allSchedules[0].station_name | slice:0:1 }}
                </div>
              }
              <div class="station-header-titles">
                <h1 class="station-header-title">{{ allSchedules[0].station_name }} - {{ allSchedules[0].station_call_sign }}</h1>
                <p class="station-header-sub">Order #{{ activeOrderId }}</p>
              </div>
            </div>
          } @else if (activeOrderId) {
            <h1>Order #{{ activeOrderId }}</h1>
            <p>Review the schedules of Order #{{ activeOrderId }}.</p>
          } @else {
            <h1>Campaigns & Schedules</h1>
            <p>Review scheduled ads at a glance. Manage campaigns easily.</p>
          }
        </div>
        </div>
        <ng-container *ngIf="(isRegularUser || isStaffRole) && activeOrderId">
          @if (isUser) {
            <button
              class="btn-help-order"
              type="button"
              (click)="helpWithOrder()"
              title="Get help with this order">
              <svg width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
              Help with this Order
            </button>
          }
          <button
            class="btn-secondary order-receipt-btn"
            type="button"
            (click)="downloadReceipt(activeOrderId!)"
            [disabled]="isDownloadingReceipt"
            [attr.aria-busy]="isDownloadingReceipt"
            title="Download PDF receipt for this order">
            @if (isDownloadingReceipt) {
              <span class="btn-spinner-dark" aria-hidden="true"></span>
              <span>Generating PDF…</span>
            } @else {
              <mat-icon aria-hidden="true">download</mat-icon>
              <span>Download Receipt</span>
            }
          </button>
        </ng-container>
      </div>

      @if (!isUser && !activeOrderId) {
        <div class="filters-container">
          <div class="filters-row-compact">
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Station ID</mat-label>
              <input matInput [(ngModel)]="allFilters.stationid" placeholder="e.g. 12" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Order ID</mat-label>
              <input matInput [(ngModel)]="allFilters.orderid" placeholder="e.g. 101" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Recording ID</mat-label>
              <input matInput [(ngModel)]="allFilters.recordingid" placeholder="e.g. 55" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field date-field">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" [(ngModel)]="allFilters.start_date" />
              <mat-icon matSuffix>calendar_today</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field date-field">
              <mat-label>End Date</mat-label>
              <input matInput type="date" [(ngModel)]="allFilters.end_date" />
              <mat-icon matSuffix>calendar_today</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Auto Fill</mat-label>
              <mat-select [(ngModel)]="allFilters.is_auto_fill">
                <mat-option [value]="''">Any</mat-option>
                <mat-option [value]="true">True</mat-option>
                <mat-option [value]="false">False</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="filter-actions">
            <button type="button" class="btn-primary action-btn" (click)="loadAll()">
              <mat-icon aria-hidden="true">search</mat-icon>
              Apply
            </button>
            <button type="button" class="btn-secondary action-btn action-btn-reset" (click)="resetAll()">
              <mat-icon aria-hidden="true">refresh</mat-icon>
              Reset
            </button>
          </div>
        </div>
      }

      <app-station-schedule-list
        [schedules]="allSchedules"
        [loading]="loadingAll"
        emptyMessage="No schedules yet"
        [showPagination]="allTotal > allLimit"
        [total]="allTotal"
        [limit]="allLimit"
        [offset]="allOffset"
        [showCustomerInfo]="isStaffRole"
        (pageChange)="loadAll($event)"
      />
    </mat-card>
  </div>
</div>

